import Alerts from './Alerts';

export { showAlert } from './Alerts';

export default Alerts;
